export default function(state=[], action) {

    switch(action.type) {
        case "TYPES":
            return action.payload;

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/ReducerFormTypes.js